import { useEffect, useRef, useState } from 'react';
import ActivityItem from './ActivityItem';

const ActivityItemBlock = ({ activities = [], isLast }) => {
  const blockRef = useRef(null);
  const count = activities.length - 1;
  const [visible, setVisible] = useState(true);

  const handleStatusClick = () => {
    if (!count) {
      return;
    }

    setVisible(!visible);
  };

  useEffect(() => {
    if (visible) {
      blockRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [visible]);

  return (
    <div
      ref={blockRef}
      className={`spo-m-dossier-sidebar-activity__item-status-block ${visible ? 'visible' : ''} ${
        isLast ? 'last' : ''
      } ${count > 0 ? 'clickable' : ''}`}
    >
      {activities?.map((a) => (
        <ActivityItem key={a.id} {...a} onStatusClick={handleStatusClick} />
      ))}
    </div>
  );
};

export default ActivityItemBlock;
